import React from "react";
import { Tab } from "semantic-ui-react";
import CCTiposDeCuentasTable from "../TablasCC/CCTiposDeCuentas/CCTiposDeCuentasTable";
import CCTiposDeDocumentosTable from "../TablasCC/CCTiposDeDocumentos/CCTiposDeDocumentosTable";
import CCTiposDeTransaccionTable from "../TablasCC/CCTiposDeTransaccion/CCTiposDeTransaccionTable";
import CCTiposTransXTiposCtaTable from "../TablasCC/CCTiposTransXTiposCta/CCTiposTransXTiposCtaTable";

const panes = [
  {
    menuItem: "Tipo de Cuenta",
    render: () => (
      <Tab.Pane>
        <CCTiposDeCuentasTable />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Tipo de Documento",
    render: () => (
      <Tab.Pane>
        <CCTiposDeDocumentosTable />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Tipo de Transaccion",
    render: () => (
      <Tab.Pane>
        <CCTiposDeTransaccionTable />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Tipo de Transaccion por Cuenta",
    render: () => (
      <Tab.Pane>
        <CCTiposTransXTiposCtaTable />
      </Tab.Pane>
    ),
  },
];

export default function FormsCC() {
  return (
    <div>
      <Tab
        menu={{ fluid: true, vertical: true }}
        menuPosition="right"
        panes={panes}
      />
    </div>
  );
}
